module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "epi"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "TXS"
  }), _vm._v(" "), _c('p', {
    staticClass: "FMEP"
  }, [_vm._v("“Stories have to be told or they die, and when they die, we can’t remember who we are or why we’re here.”")]), _vm._v(" "), _c('p', {
    staticClass: "FMEPC"
  }, [_vm._v("—Sue Monk Kidd, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Secret Life of Bees")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6efe7073","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 69
// module chunks = 0